import dynamic from 'next/dynamic'

import { ConsultSection } from './ConsultSection'
import { CustomHeaderSection } from './CustomHeaderSection'
import { ExperienceSoftwareSection } from './ExperienceSoftwareSection'
import { ExpertiseSection } from './ExpertiseSection'
import { ExtensiveTechStack } from './ExtensiveTechStack'
import { HallMarksSection } from './HallMarksSection'
import { KeyFactsSection } from './KeyFactsSection'
import { SuccessStorySection } from './SuccessStorySection'
import { TransparentSoftwareSection } from './TransparentSoftwareSection'

const FeedbackSection = dynamic(() =>
  import('@dynamic-components/sections/FeedbackSection')
)

export function CustomSoftwareDevelopment() {
  return (
    <>
      <CustomHeaderSection />
      <HallMarksSection />
      <ExtensiveTechStack />
      <TransparentSoftwareSection />
      <KeyFactsSection />
      <ConsultSection />
      <ExperienceSoftwareSection />
      <ExpertiseSection />
      <SuccessStorySection />
      <FeedbackSection />
    </>
  )
}
